import api from '../../api/index.js'

const state = {

}

const getters = {
}

const actions = {

    getCustomRemarkClassList({commit}, payload) { 
        return new Promise((resolve, reject) => {
            api.get('/CustomRemark/CustomRemarkClassList',payload, res => {
                resolve(res.Result)
            }, err => {
                reject(err)
            })
        })
    },
    getCustomRemarkList({commit}, payload)
    {
        return new Promise((resolve, reject) => {
            api.get('/CustomRemark/List',payload, res => {
                resolve(res.Result)
            }, err => {
                reject(err)
            })
        })

    }

}

const mutations = {
}

export default {
    state,
    getters,
    actions,
    mutations
}
